import { useCallback } from 'react';
import { prop, pick } from 'js/utils/ramda.util';
import { getURLParams } from 'js/utils/url.util';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import * as helpers from './helpers';

export const useIsNavigationBarAvailable = (url) => {
    const { hideNav } = getURLParams(location.search);
    const formFactor = useDeviceSelector(prop('formFactor'));
    const { rootPage, menuItems } = useAppSelector(pick(['rootPage', 'menuItems']));

    return useCallback(() => {
        if (formFactor === 'mobile') {
            return false;
        }

        if (!menuItems || !menuItems.length) {
            return false;
        }

        const currentMenuItem = helpers.getMenuItemByURL(menuItems, url || rootPage);

        if (!currentMenuItem || hideNav === '1') {
            return false;
        }

        if (formFactor === 'desktop') {
            return Boolean(currentMenuItem.showNavigationBarDesktop);
        } else if (formFactor === 'tablet') {
            return Boolean(currentMenuItem.showNavigationBarTablet);
        }

        return false;
    }, [formFactor, url, hideNav, menuItems, rootPage]);
};
